import React, { ComponentPropsWithoutRef, ElementType } from 'react';

import { ReactComponent as BackSVG } from '../../../assets/icons/back.svg';
import { ReactComponent as BuildingSVG } from '../../../assets/icons/building.svg';
import { ReactComponent as RoadSVG } from '../../../assets/icons/road.svg';
import { ReactComponent as SpeedLimitSVG } from '../../../assets/icons/speed-limit.svg';
import { ReactComponent as PinCurvySVG } from '../../../assets/icons/pin-curvy.svg';
import { ReactComponent as CameraSVG } from '../../../assets/icons/camera.svg';
import { ReactComponent as CrossSVG } from '../../../assets/icons/cross.svg';
import { ReactComponent as CrossCircleSVG } from '../../../assets/icons/cross-circle.svg';
import { ReactComponent as CrossBoldSVG } from '../../../assets/icons/cross-bold.svg';
import { ReactComponent as LocationSVG } from '../../../assets/icons/location.svg';
import { ReactComponent as MagnifyingGlassSVG } from '../../../assets/icons/magnifying-glass.svg';
import { ReactComponent as MagnifyingGlassAddSVG } from '../../../assets/icons/magnifying-glass-add.svg';
import { ReactComponent as NinjaStarSVG } from '../../../assets/icons/ninja-star.svg';
import { ReactComponent as PinSVG } from '../../../assets/icons/pin.svg';
import { ReactComponent as PlusSVG } from '../../../assets/icons/plus.svg';
import { ReactComponent as PlusBoldSVG } from '../../../assets/icons/plus-bold.svg';
import { ReactComponent as PlusCircleSVG } from '../../../assets/icons/plus-circle.svg';
import { ReactComponent as MinusSVG } from '../../../assets/icons/minus.svg';
import { ReactComponent as WarningCircleSVG } from '../../../assets/icons/warning-circle.svg';
import { ReactComponent as CrossCircleBoldSVG } from '../../../assets/icons/cross-circle-bold.svg';
import { ReactComponent as DoubleMarkerSVG } from '../../../assets/icons/double-marker.svg';
import { ReactComponent as EllipsisSVG } from '../../../assets/icons/ellipsis.svg';
import { ReactComponent as ExclamationMarkMarkerSVG } from '../../../assets/icons/exclamation-mark-marker.svg';
import { ReactComponent as TimeCircleSVG } from '../../../assets/icons/time-circle.svg';
import { ReactComponent as ArrowLeftSVG } from '../../../assets/icons/arrow-left.svg';
import { ReactComponent as HandTapSVG } from '../../../assets/icons/hand-tap.svg';
import { ReactComponent as Marker } from '../../../assets/icons/marker.svg';
import { ReactComponent as MarkerCircleSVG } from '../../../assets/icons/marker-circle.svg';
import { ReactComponent as QuestionMarker } from '../../../assets/icons/question-marker.svg';
import { ReactComponent as LayersSVG } from '../../../assets/icons/layers.svg';
import { ReactComponent as ScoreStarSVG } from '../../../assets/icons/score-star.svg';
import { ReactComponent as IncidentSVG } from '../../../assets/icons/incident.svg';
import { ReactComponent as ClearanceSVG } from '../../../assets/icons/clearance.svg';
// POI markers:
import { ReactComponent as DefaultPOIMarker } from '../../../assets/icons/poi_markers/marker_40px_selected.svg';
import { ReactComponent as AerialwayPOIMarker } from '../../../assets/icons/poi_markers/aerialway_40px_selected.svg';
import { ReactComponent as AirfieldPOIMarker } from '../../../assets/icons/poi_markers/airfield_40px_selected.svg';
import { ReactComponent as AirportPOIMarker } from '../../../assets/icons/poi_markers/airport_40px_selected.svg';
import { ReactComponent as AlcoholshopPOIMarker } from '../../../assets/icons/poi_markers/alcohol-shop_40px_selected.svg';
import { ReactComponent as AmericanfootballPOIMarker } from '../../../assets/icons/poi_markers/american-football_40px_selected.svg';
import { ReactComponent as AmusementparkPOIMarker } from '../../../assets/icons/poi_markers/amusement-park_40px_selected.svg';
import { ReactComponent as AquariumPOIMarker } from '../../../assets/icons/poi_markers/aquarium_40px_selected.svg';
import { ReactComponent as ArrowPOIMarker } from '../../../assets/icons/poi_markers/arrow_40px_selected.svg';
import { ReactComponent as ArtgalleryPOIMarker } from '../../../assets/icons/poi_markers/art-gallery_40px_selected.svg';
import { ReactComponent as AttractionPOIMarker } from '../../../assets/icons/poi_markers/attraction_40px_selected.svg';
import { ReactComponent as BakeryPOIMarker } from '../../../assets/icons/poi_markers/bakery_40px_selected.svg';
import { ReactComponent as BankjpPOIMarker } from '../../../assets/icons/poi_markers/bank-JP_40px_selected.svg';
import { ReactComponent as BankPOIMarker } from '../../../assets/icons/poi_markers/bank_40px_selected.svg';
import { ReactComponent as BarPOIMarker } from '../../../assets/icons/poi_markers/bar_40px_selected.svg';
import { ReactComponent as BarrierPOIMarker } from '../../../assets/icons/poi_markers/barrier_40px_selected.svg';
import { ReactComponent as BaseballPOIMarker } from '../../../assets/icons/poi_markers/baseball_40px_selected.svg';
import { ReactComponent as BasketballPOIMarker } from '../../../assets/icons/poi_markers/basketball_40px_selected.svg';
import { ReactComponent as BbqPOIMarker } from '../../../assets/icons/poi_markers/bbq_40px_selected.svg';
import { ReactComponent as BeachPOIMarker } from '../../../assets/icons/poi_markers/beach_40px_selected.svg';
import { ReactComponent as BeerPOIMarker } from '../../../assets/icons/poi_markers/beer_40px_selected.svg';
import { ReactComponent as BicyclesharePOIMarker } from '../../../assets/icons/poi_markers/bicycle-share_40px_selected.svg';
import { ReactComponent as BicyclePOIMarker } from '../../../assets/icons/poi_markers/bicycle_40px_selected.svg';
import { ReactComponent as BloodbankPOIMarker } from '../../../assets/icons/poi_markers/blood-bank_40px_selected.svg';
import { ReactComponent as BowlingalleyPOIMarker } from '../../../assets/icons/poi_markers/bowling-alley_40px_selected.svg';
import { ReactComponent as BridgePOIMarker } from '../../../assets/icons/poi_markers/bridge_40px_selected.svg';
import { ReactComponent as Buildingalt1POIMarker } from '../../../assets/icons/poi_markers/building-alt1_40px_selected.svg';
import { ReactComponent as BuildingPOIMarker } from '../../../assets/icons/poi_markers/building_40px_selected.svg';
import { ReactComponent as BusPOIMarker } from '../../../assets/icons/poi_markers/bus_40px_selected.svg';
import { ReactComponent as CafePOIMarker } from '../../../assets/icons/poi_markers/cafe_40px_selected.svg';
import { ReactComponent as CampsitePOIMarker } from '../../../assets/icons/poi_markers/campsite_40px_selected.svg';
import { ReactComponent as CarrentalPOIMarker } from '../../../assets/icons/poi_markers/car-rental_40px_selected.svg';
import { ReactComponent as CarrepairPOIMarker } from '../../../assets/icons/poi_markers/car-repair_40px_selected.svg';
import { ReactComponent as CarPOIMarker } from '../../../assets/icons/poi_markers/car_40px_selected.svg';
import { ReactComponent as CasinoPOIMarker } from '../../../assets/icons/poi_markers/casino_40px_selected.svg';
import { ReactComponent as CastlejpPOIMarker } from '../../../assets/icons/poi_markers/castle-JP_40px_selected.svg';
import { ReactComponent as CastlePOIMarker } from '../../../assets/icons/poi_markers/castle_40px_selected.svg';
import { ReactComponent as CautionPOIMarker } from '../../../assets/icons/poi_markers/caution_40px_selected.svg';
import { ReactComponent as CemeteryjpPOIMarker } from '../../../assets/icons/poi_markers/cemetery-JP_40px_selected.svg';
import { ReactComponent as CemeteryPOIMarker } from '../../../assets/icons/poi_markers/cemetery_40px_selected.svg';
import { ReactComponent as ChargingstationPOIMarker } from '../../../assets/icons/poi_markers/charging-station_40px_selected.svg';
import { ReactComponent as CinemaPOIMarker } from '../../../assets/icons/poi_markers/cinema_40px_selected.svg';
import { ReactComponent as CirclestrokedPOIMarker } from '../../../assets/icons/poi_markers/circle-stroked_40px_selected.svg';
import { ReactComponent as CirclePOIMarker } from '../../../assets/icons/poi_markers/circle_40px_selected.svg';
import { ReactComponent as CityPOIMarker } from '../../../assets/icons/poi_markers/city_40px_selected.svg';
import { ReactComponent as ClothingstorePOIMarker } from '../../../assets/icons/poi_markers/clothing-store_40px_selected.svg';
import { ReactComponent as CollegejpPOIMarker } from '../../../assets/icons/poi_markers/college-JP_40px_selected.svg';
import { ReactComponent as CollegePOIMarker } from '../../../assets/icons/poi_markers/college_40px_selected.svg';
import { ReactComponent as CommercialPOIMarker } from '../../../assets/icons/poi_markers/commercial_40px_selected.svg';
import { ReactComponent as CommunicationstowerPOIMarker } from '../../../assets/icons/poi_markers/communications-tower_40px_selected.svg';
import { ReactComponent as ConfectioneryPOIMarker } from '../../../assets/icons/poi_markers/confectionery_40px_selected.svg';
import { ReactComponent as ConstructionPOIMarker } from '../../../assets/icons/poi_markers/construction_40px_selected.svg';
import { ReactComponent as ConveniencePOIMarker } from '../../../assets/icons/poi_markers/convenience_40px_selected.svg';
import { ReactComponent as CricketPOIMarker } from '../../../assets/icons/poi_markers/cricket_40px_selected.svg';
import { ReactComponent as CrossPOIMarker } from '../../../assets/icons/poi_markers/cross_40px_selected.svg';
import { ReactComponent as DamPOIMarker } from '../../../assets/icons/poi_markers/dam_40px_selected.svg';
import { ReactComponent as DangerPOIMarker } from '../../../assets/icons/poi_markers/danger_40px_selected.svg';
import { ReactComponent as DefibrillatorPOIMarker } from '../../../assets/icons/poi_markers/defibrillator_40px_selected.svg';
import { ReactComponent as DentistPOIMarker } from '../../../assets/icons/poi_markers/dentist_40px_selected.svg';
import { ReactComponent as DiamondPOIMarker } from '../../../assets/icons/poi_markers/diamond_40px_selected.svg';
import { ReactComponent as DoctorPOIMarker } from '../../../assets/icons/poi_markers/doctor_40px_selected.svg';
import { ReactComponent as DogparkPOIMarker } from '../../../assets/icons/poi_markers/dog-park_40px_selected.svg';
import { ReactComponent as DrinkingwaterPOIMarker } from '../../../assets/icons/poi_markers/drinking-water_40px_selected.svg';
import { ReactComponent as ElevatorPOIMarker } from '../../../assets/icons/poi_markers/elevator_40px_selected.svg';
import { ReactComponent as EmbassyPOIMarker } from '../../../assets/icons/poi_markers/embassy_40px_selected.svg';
import { ReactComponent as EmergencyphonePOIMarker } from '../../../assets/icons/poi_markers/emergency-phone_40px_selected.svg';
import { ReactComponent as Entrancealt1POIMarker } from '../../../assets/icons/poi_markers/entrance-alt1_40px_selected.svg';
import { ReactComponent as EntrancePOIMarker } from '../../../assets/icons/poi_markers/entrance_40px_selected.svg';
import { ReactComponent as FarmPOIMarker } from '../../../assets/icons/poi_markers/farm_40px_selected.svg';
import { ReactComponent as FastfoodPOIMarker } from '../../../assets/icons/poi_markers/fast-food_40px_selected.svg';
import { ReactComponent as FencePOIMarker } from '../../../assets/icons/poi_markers/fence_40px_selected.svg';
import { ReactComponent as FerryjpPOIMarker } from '../../../assets/icons/poi_markers/ferry-JP_40px_selected.svg';
import { ReactComponent as FerryPOIMarker } from '../../../assets/icons/poi_markers/ferry_40px_selected.svg';
import { ReactComponent as FirestationjpPOIMarker } from '../../../assets/icons/poi_markers/fire-station-JP_40px_selected.svg';
import { ReactComponent as FirestationPOIMarker } from '../../../assets/icons/poi_markers/fire-station_40px_selected.svg';
import { ReactComponent as FitnesscentrePOIMarker } from '../../../assets/icons/poi_markers/fitness-centre_40px_selected.svg';
import { ReactComponent as FloristPOIMarker } from '../../../assets/icons/poi_markers/florist_40px_selected.svg';
import { ReactComponent as FuelPOIMarker } from '../../../assets/icons/poi_markers/fuel_40px_selected.svg';
import { ReactComponent as FurniturePOIMarker } from '../../../assets/icons/poi_markers/furniture_40px_selected.svg';
import { ReactComponent as GamingPOIMarker } from '../../../assets/icons/poi_markers/gaming_40px_selected.svg';
import { ReactComponent as GardencentrePOIMarker } from '../../../assets/icons/poi_markers/garden-centre_40px_selected.svg';
import { ReactComponent as GardenPOIMarker } from '../../../assets/icons/poi_markers/garden_40px_selected.svg';
import { ReactComponent as GiftPOIMarker } from '../../../assets/icons/poi_markers/gift_40px_selected.svg';
import { ReactComponent as GlobePOIMarker } from '../../../assets/icons/poi_markers/globe_40px_selected.svg';
import { ReactComponent as GolfPOIMarker } from '../../../assets/icons/poi_markers/golf_40px_selected.svg';
import { ReactComponent as GroceryPOIMarker } from '../../../assets/icons/poi_markers/grocery_40px_selected.svg';
import { ReactComponent as HairdresserPOIMarker } from '../../../assets/icons/poi_markers/hairdresser_40px_selected.svg';
import { ReactComponent as HarborPOIMarker } from '../../../assets/icons/poi_markers/harbor_40px_selected.svg';
import { ReactComponent as HardwarePOIMarker } from '../../../assets/icons/poi_markers/hardware_40px_selected.svg';
import { ReactComponent as HeartPOIMarker } from '../../../assets/icons/poi_markers/heart_40px_selected.svg';
import { ReactComponent as HeliportPOIMarker } from '../../../assets/icons/poi_markers/heliport_40px_selected.svg';
import { ReactComponent as HighwayrestareaPOIMarker } from '../../../assets/icons/poi_markers/highway-rest-area_40px_selected.svg';
import { ReactComponent as HomePOIMarker } from '../../../assets/icons/poi_markers/home_40px_selected.svg';
import { ReactComponent as HorseridingPOIMarker } from '../../../assets/icons/poi_markers/horse-riding_40px_selected.svg';
import { ReactComponent as HospitaljpPOIMarker } from '../../../assets/icons/poi_markers/hospital-JP_40px_selected.svg';
import { ReactComponent as HospitalPOIMarker } from '../../../assets/icons/poi_markers/hospital_40px_selected.svg';
import { ReactComponent as HotspringPOIMarker } from '../../../assets/icons/poi_markers/hot-spring_40px_selected.svg';
import { ReactComponent as IcecreamPOIMarker } from '../../../assets/icons/poi_markers/ice-cream_40px_selected.svg';
import { ReactComponent as IndustryPOIMarker } from '../../../assets/icons/poi_markers/industry_40px_selected.svg';
import { ReactComponent as InformationPOIMarker } from '../../../assets/icons/poi_markers/information_40px_selected.svg';
import { ReactComponent as JewelrystorePOIMarker } from '../../../assets/icons/poi_markers/jewelry-store_40px_selected.svg';
import { ReactComponent as KaraokePOIMarker } from '../../../assets/icons/poi_markers/karaoke_40px_selected.svg';
import { ReactComponent as LandmarkjpPOIMarker } from '../../../assets/icons/poi_markers/landmark-JP_40px_selected.svg';
import { ReactComponent as LandmarkPOIMarker } from '../../../assets/icons/poi_markers/landmark_40px_selected.svg';
import { ReactComponent as LandusePOIMarker } from '../../../assets/icons/poi_markers/landuse_40px_selected.svg';
import { ReactComponent as LaundryPOIMarker } from '../../../assets/icons/poi_markers/laundry_40px_selected.svg';
import { ReactComponent as LibraryPOIMarker } from '../../../assets/icons/poi_markers/library_40px_selected.svg';
import { ReactComponent as LighthousejpPOIMarker } from '../../../assets/icons/poi_markers/lighthouse-JP_40px_selected.svg';
import { ReactComponent as LighthousePOIMarker } from '../../../assets/icons/poi_markers/lighthouse_40px_selected.svg';
import { ReactComponent as LodgingPOIMarker } from '../../../assets/icons/poi_markers/lodging_40px_selected.svg';
import { ReactComponent as LoggingPOIMarker } from '../../../assets/icons/poi_markers/logging_40px_selected.svg';
import { ReactComponent as MarkerstrokedPOIMarker } from '../../../assets/icons/poi_markers/marker-stroked_40px_selected.svg';
import { ReactComponent as MobilephonePOIMarker } from '../../../assets/icons/poi_markers/mobile-phone_40px_selected.svg';
import { ReactComponent as MonumentjpPOIMarker } from '../../../assets/icons/poi_markers/monument-JP_40px_selected.svg';
import { ReactComponent as MonumentPOIMarker } from '../../../assets/icons/poi_markers/monument_40px_selected.svg';
import { ReactComponent as MountainPOIMarker } from '../../../assets/icons/poi_markers/mountain_40px_selected.svg';
import { ReactComponent as MuseumPOIMarker } from '../../../assets/icons/poi_markers/museum_40px_selected.svg';
import { ReactComponent as MusicPOIMarker } from '../../../assets/icons/poi_markers/music_40px_selected.svg';
import { ReactComponent as NaturalPOIMarker } from '../../../assets/icons/poi_markers/natural_40px_selected.svg';
import { ReactComponent as ObservationtowerPOIMarker } from '../../../assets/icons/poi_markers/observation-tower_40px_selected.svg';
import { ReactComponent as OpticianPOIMarker } from '../../../assets/icons/poi_markers/optician_40px_selected.svg';
import { ReactComponent as PaintPOIMarker } from '../../../assets/icons/poi_markers/paint_40px_selected.svg';
import { ReactComponent as Parkalt1POIMarker } from '../../../assets/icons/poi_markers/park-alt1_40px_selected.svg';
import { ReactComponent as ParkPOIMarker } from '../../../assets/icons/poi_markers/park_40px_selected.svg';
import { ReactComponent as ParkinggaragePOIMarker } from '../../../assets/icons/poi_markers/parking-garage_40px_selected.svg';
import { ReactComponent as ParkingPOIMarker } from '../../../assets/icons/poi_markers/parking_40px_selected.svg';
import { ReactComponent as PharmacyPOIMarker } from '../../../assets/icons/poi_markers/pharmacy_40px_selected.svg';
import { ReactComponent as PicnicsitePOIMarker } from '../../../assets/icons/poi_markers/picnic-site_40px_selected.svg';
import { ReactComponent as PitchPOIMarker } from '../../../assets/icons/poi_markers/pitch_40px_selected.svg';
import { ReactComponent as PlaceofworshipPOIMarker } from '../../../assets/icons/poi_markers/place-of-worship_40px_selected.svg';
import { ReactComponent as PlaygroundPOIMarker } from '../../../assets/icons/poi_markers/playground_40px_selected.svg';
import { ReactComponent as PolicejpPOIMarker } from '../../../assets/icons/poi_markers/police-JP_40px_selected.svg';
import { ReactComponent as PolicePOIMarker } from '../../../assets/icons/poi_markers/police_40px_selected.svg';
import { ReactComponent as PostjpPOIMarker } from '../../../assets/icons/poi_markers/post-JP_40px_selected.svg';
import { ReactComponent as PostPOIMarker } from '../../../assets/icons/poi_markers/post_40px_selected.svg';
import { ReactComponent as PrisonPOIMarker } from '../../../assets/icons/poi_markers/prison_40px_selected.svg';
import { ReactComponent as RacetrackboatPOIMarker } from '../../../assets/icons/poi_markers/racetrack-boat_40px_selected.svg';
import { ReactComponent as RacetrackcyclingPOIMarker } from '../../../assets/icons/poi_markers/racetrack-cycling_40px_selected.svg';
import { ReactComponent as RacetrackhorsePOIMarker } from '../../../assets/icons/poi_markers/racetrack-horse_40px_selected.svg';
import { ReactComponent as RacetrackPOIMarker } from '../../../assets/icons/poi_markers/racetrack_40px_selected.svg';
import { ReactComponent as RaillightPOIMarker } from '../../../assets/icons/poi_markers/rail-light_40px_selected.svg';
import { ReactComponent as RailmetroPOIMarker } from '../../../assets/icons/poi_markers/rail-metro_40px_selected.svg';
import { ReactComponent as RailPOIMarker } from '../../../assets/icons/poi_markers/rail_40px_selected.svg';
import { ReactComponent as RangerstationPOIMarker } from '../../../assets/icons/poi_markers/ranger-station_40px_selected.svg';
import { ReactComponent as RecyclingPOIMarker } from '../../../assets/icons/poi_markers/recycling_40px_selected.svg';
import { ReactComponent as ReligiousbuddhistPOIMarker } from '../../../assets/icons/poi_markers/religious-buddhist_40px_selected.svg';
import { ReactComponent as ReligiouschristianPOIMarker } from '../../../assets/icons/poi_markers/religious-christian_40px_selected.svg';
import { ReactComponent as ReligiousjewishPOIMarker } from '../../../assets/icons/poi_markers/religious-jewish_40px_selected.svg';
import { ReactComponent as ReligiousmuslimPOIMarker } from '../../../assets/icons/poi_markers/religious-muslim_40px_selected.svg';
import { ReactComponent as ReligiousshintoPOIMarker } from '../../../assets/icons/poi_markers/religious-shinto_40px_selected.svg';
import { ReactComponent as ResidentialcommunityPOIMarker } from '../../../assets/icons/poi_markers/residential-community_40px_selected.svg';
import { ReactComponent as RestaurantbbqPOIMarker } from '../../../assets/icons/poi_markers/restaurant-bbq_40px_selected.svg';
import { ReactComponent as RestaurantnoodlePOIMarker } from '../../../assets/icons/poi_markers/restaurant-noodle_40px_selected.svg';
import { ReactComponent as RestaurantpizzaPOIMarker } from '../../../assets/icons/poi_markers/restaurant-pizza_40px_selected.svg';
import { ReactComponent as RestaurantseafoodPOIMarker } from '../../../assets/icons/poi_markers/restaurant-seafood_40px_selected.svg';
import { ReactComponent as RestaurantsushiPOIMarker } from '../../../assets/icons/poi_markers/restaurant-sushi_40px_selected.svg';
import { ReactComponent as RestaurantPOIMarker } from '../../../assets/icons/poi_markers/restaurant_40px_selected.svg';
import { ReactComponent as RoadaccidentPOIMarker } from '../../../assets/icons/poi_markers/road-accident_40px_selected.svg';
import { ReactComponent as RoadblockPOIMarker } from '../../../assets/icons/poi_markers/roadblock_40px_selected.svg';
import { ReactComponent as RocketPOIMarker } from '../../../assets/icons/poi_markers/rocket_40px_selected.svg';
import { ReactComponent as SchooljpPOIMarker } from '../../../assets/icons/poi_markers/school-JP_40px_selected.svg';
import { ReactComponent as SchoolPOIMarker } from '../../../assets/icons/poi_markers/school_40px_selected.svg';
import { ReactComponent as ScooterPOIMarker } from '../../../assets/icons/poi_markers/scooter_40px_selected.svg';
import { ReactComponent as ShelterPOIMarker } from '../../../assets/icons/poi_markers/shelter_40px_selected.svg';
import { ReactComponent as ShoePOIMarker } from '../../../assets/icons/poi_markers/shoe_40px_selected.svg';
import { ReactComponent as ShopPOIMarker } from '../../../assets/icons/poi_markers/shop_40px_selected.svg';
import { ReactComponent as SkateboardPOIMarker } from '../../../assets/icons/poi_markers/skateboard_40px_selected.svg';
import { ReactComponent as SkiingPOIMarker } from '../../../assets/icons/poi_markers/skiing_40px_selected.svg';
import { ReactComponent as SlaughterhousePOIMarker } from '../../../assets/icons/poi_markers/slaughterhouse_40px_selected.svg';
import { ReactComponent as SlipwayPOIMarker } from '../../../assets/icons/poi_markers/slipway_40px_selected.svg';
import { ReactComponent as SnowmobilePOIMarker } from '../../../assets/icons/poi_markers/snowmobile_40px_selected.svg';
import { ReactComponent as SoccerPOIMarker } from '../../../assets/icons/poi_markers/soccer_40px_selected.svg';
import { ReactComponent as SquarestrokedPOIMarker } from '../../../assets/icons/poi_markers/square-stroked_40px_selected.svg';
import { ReactComponent as SquarePOIMarker } from '../../../assets/icons/poi_markers/square_40px_selected.svg';
import { ReactComponent as StadiumPOIMarker } from '../../../assets/icons/poi_markers/stadium_40px_selected.svg';
import { ReactComponent as StarstrokedPOIMarker } from '../../../assets/icons/poi_markers/star-stroked_40px_selected.svg';
import { ReactComponent as StarPOIMarker } from '../../../assets/icons/poi_markers/star_40px_selected.svg';
import { ReactComponent as SuitcasePOIMarker } from '../../../assets/icons/poi_markers/suitcase_40px_selected.svg';
import { ReactComponent as SwimmingPOIMarker } from '../../../assets/icons/poi_markers/swimming_40px_selected.svg';
import { ReactComponent as TabletennisPOIMarker } from '../../../assets/icons/poi_markers/table-tennis_40px_selected.svg';
import { ReactComponent as TeahousePOIMarker } from '../../../assets/icons/poi_markers/teahouse_40px_selected.svg';
import { ReactComponent as TelephonePOIMarker } from '../../../assets/icons/poi_markers/telephone_40px_selected.svg';
import { ReactComponent as TennisPOIMarker } from '../../../assets/icons/poi_markers/tennis_40px_selected.svg';
import { ReactComponent as TheatrePOIMarker } from '../../../assets/icons/poi_markers/theatre_40px_selected.svg';
import { ReactComponent as ToiletPOIMarker } from '../../../assets/icons/poi_markers/toilet_40px_selected.svg';
import { ReactComponent as TownhallPOIMarker } from '../../../assets/icons/poi_markers/town-hall_40px_selected.svg';
import { ReactComponent as TownPOIMarker } from '../../../assets/icons/poi_markers/town_40px_selected.svg';
import { ReactComponent as TrianglestrokedPOIMarker } from '../../../assets/icons/poi_markers/triangle-stroked_40px_selected.svg';
import { ReactComponent as TrianglePOIMarker } from '../../../assets/icons/poi_markers/triangle_40px_selected.svg';
import { ReactComponent as VeterinaryPOIMarker } from '../../../assets/icons/poi_markers/veterinary_40px_selected.svg';
import { ReactComponent as ViewpointPOIMarker } from '../../../assets/icons/poi_markers/viewpoint_40px_selected.svg';
import { ReactComponent as VillagePOIMarker } from '../../../assets/icons/poi_markers/village_40px_selected.svg';
import { ReactComponent as VolcanoPOIMarker } from '../../../assets/icons/poi_markers/volcano_40px_selected.svg';
import { ReactComponent as VolleyballPOIMarker } from '../../../assets/icons/poi_markers/volleyball_40px_selected.svg';
import { ReactComponent as WarehousePOIMarker } from '../../../assets/icons/poi_markers/warehouse_40px_selected.svg';
import { ReactComponent as WastebasketPOIMarker } from '../../../assets/icons/poi_markers/waste-basket_40px_selected.svg';
import { ReactComponent as WatchPOIMarker } from '../../../assets/icons/poi_markers/watch_40px_selected.svg';
import { ReactComponent as WaterPOIMarker } from '../../../assets/icons/poi_markers/water_40px_selected.svg';
import { ReactComponent as WaterfallPOIMarker } from '../../../assets/icons/poi_markers/waterfall_40px_selected.svg';
import { ReactComponent as WatermillPOIMarker } from '../../../assets/icons/poi_markers/watermill_40px_selected.svg';
import { ReactComponent as WetlandPOIMarker } from '../../../assets/icons/poi_markers/wetland_40px_selected.svg';
import { ReactComponent as WheelchairPOIMarker } from '../../../assets/icons/poi_markers/wheelchair_40px_selected.svg';
import { ReactComponent as WindmillPOIMarker } from '../../../assets/icons/poi_markers/windmill_40px_selected.svg';
import { ReactComponent as ZooPOIMarker } from '../../../assets/icons/poi_markers/zoo_40px_selected.svg';
import { ReactComponent as ZoomInSVG } from '../../../assets/icons/zoom-in.svg';

const iconsMap = {
  back: { Component: BackSVG },
  building: { Component: BuildingSVG },
  road: { Component: RoadSVG },
  'speed-limit': { Component: SpeedLimitSVG },
  'pin-curvy': { Component: PinCurvySVG },
  camera: { Component: CameraSVG },
  cross: { Component: CrossSVG },
  'cross-circle': { Component: CrossCircleSVG },
  'cross-bold': { Component: CrossBoldSVG },
  location: { Component: LocationSVG },
  'magnifying-glass': { Component: MagnifyingGlassSVG },
  'magnifying-glass-add': { Component: MagnifyingGlassAddSVG },
  'ninja-star': { Component: NinjaStarSVG },
  pin: { Component: PinSVG },
  plus: { Component: PlusSVG },
  'plus-bold': { Component: PlusBoldSVG },
  'plus-circle': { Component: PlusCircleSVG },
  minus: { Component: MinusSVG },
  'warning-circle': { Component: WarningCircleSVG },
  'cross-circle-bold': { Component: CrossCircleBoldSVG },
  'double-marker': { Component: DoubleMarkerSVG },
  ellipsis: { Component: EllipsisSVG },
  'exclamation-mark-marker': { Component: ExclamationMarkMarkerSVG },
  'time-circle': { Component: TimeCircleSVG },
  'arrow-left': { Component: ArrowLeftSVG },
  'hand-tap': { Component: HandTapSVG },
  marker: { Component: Marker },
  'marker-circle': { Component: MarkerCircleSVG },
  'question-marker': { Component: QuestionMarker },
  layers: { Component: LayersSVG },
  'score-star': { Component: ScoreStarSVG },
  incident: { Component: IncidentSVG },
  clearance: { Component: ClearanceSVG },
  // POI markers:
  'default-poi': { Component: DefaultPOIMarker },
  'aerialway-poi': { Component: AerialwayPOIMarker },
  'airfield-poi': { Component: AirfieldPOIMarker },
  'airport-poi': { Component: AirportPOIMarker },
  'alcohol-shop-poi': { Component: AlcoholshopPOIMarker },
  'american-football-poi': { Component: AmericanfootballPOIMarker },
  'amusement-park-poi': { Component: AmusementparkPOIMarker },
  'aquarium-poi': { Component: AquariumPOIMarker },
  'arrow-poi': { Component: ArrowPOIMarker },
  'art-gallery-poi': { Component: ArtgalleryPOIMarker },
  'attraction-poi': { Component: AttractionPOIMarker },
  'bakery-poi': { Component: BakeryPOIMarker },
  'bank-JP-poi': { Component: BankjpPOIMarker },
  'bank-poi': { Component: BankPOIMarker },
  'bar-poi': { Component: BarPOIMarker },
  'barrier-poi': { Component: BarrierPOIMarker },
  'baseball-poi': { Component: BaseballPOIMarker },
  'basketball-poi': { Component: BasketballPOIMarker },
  'bbq-poi': { Component: BbqPOIMarker },
  'beach-poi': { Component: BeachPOIMarker },
  'beer-poi': { Component: BeerPOIMarker },
  'bicycle-share-poi': { Component: BicyclesharePOIMarker },
  'bicycle-poi': { Component: BicyclePOIMarker },
  'blood-bank-poi': { Component: BloodbankPOIMarker },
  'bowling-alley-poi': { Component: BowlingalleyPOIMarker },
  'bridge-poi': { Component: BridgePOIMarker },
  'building-alt1-poi': { Component: Buildingalt1POIMarker },
  'building-poi': { Component: BuildingPOIMarker },
  'bus-poi': { Component: BusPOIMarker },
  'cafe-poi': { Component: CafePOIMarker },
  'campsite-poi': { Component: CampsitePOIMarker },
  'car-rental-poi': { Component: CarrentalPOIMarker },
  'car-repair-poi': { Component: CarrepairPOIMarker },
  'car-poi': { Component: CarPOIMarker },
  'casino-poi': { Component: CasinoPOIMarker },
  'castle-JP-poi': { Component: CastlejpPOIMarker },
  'castle-poi': { Component: CastlePOIMarker },
  'caution-poi': { Component: CautionPOIMarker },
  'cemetery-JP-poi': { Component: CemeteryjpPOIMarker },
  'cemetery-poi': { Component: CemeteryPOIMarker },
  'charging-station-poi': { Component: ChargingstationPOIMarker },
  'cinema-poi': { Component: CinemaPOIMarker },
  'circle-stroked-poi': { Component: CirclestrokedPOIMarker },
  'circle-poi': { Component: CirclePOIMarker },
  'city-poi': { Component: CityPOIMarker },
  'clothing-store-poi': { Component: ClothingstorePOIMarker },
  'college-JP-poi': { Component: CollegejpPOIMarker },
  'college-poi': { Component: CollegePOIMarker },
  'commercial-poi': { Component: CommercialPOIMarker },
  'communications-tower-poi': { Component: CommunicationstowerPOIMarker },
  'confectionery-poi': { Component: ConfectioneryPOIMarker },
  'construction-poi': { Component: ConstructionPOIMarker },
  'convenience-poi': { Component: ConveniencePOIMarker },
  'cricket-poi': { Component: CricketPOIMarker },
  'cross-poi': { Component: CrossPOIMarker },
  'dam-poi': { Component: DamPOIMarker },
  'danger-poi': { Component: DangerPOIMarker },
  'defibrillator-poi': { Component: DefibrillatorPOIMarker },
  'dentist-poi': { Component: DentistPOIMarker },
  'diamond-poi': { Component: DiamondPOIMarker },
  'doctor-poi': { Component: DoctorPOIMarker },
  'dog-park-poi': { Component: DogparkPOIMarker },
  'drinking-water-poi': { Component: DrinkingwaterPOIMarker },
  'elevator-poi': { Component: ElevatorPOIMarker },
  'embassy-poi': { Component: EmbassyPOIMarker },
  'emergency-phone-poi': { Component: EmergencyphonePOIMarker },
  'entrance-alt1-poi': { Component: Entrancealt1POIMarker },
  'entrance-poi': { Component: EntrancePOIMarker },
  'farm-poi': { Component: FarmPOIMarker },
  'fast-food-poi': { Component: FastfoodPOIMarker },
  'fence-poi': { Component: FencePOIMarker },
  'ferry-JP-poi': { Component: FerryjpPOIMarker },
  'ferry-poi': { Component: FerryPOIMarker },
  'fire-station-JP-poi': { Component: FirestationjpPOIMarker },
  'fire-station-poi': { Component: FirestationPOIMarker },
  'fitness-centre-poi': { Component: FitnesscentrePOIMarker },
  'florist-poi': { Component: FloristPOIMarker },
  'fuel-poi': { Component: FuelPOIMarker },
  'furniture-poi': { Component: FurniturePOIMarker },
  'gaming-poi': { Component: GamingPOIMarker },
  'garden-centre-poi': { Component: GardencentrePOIMarker },
  'garden-poi': { Component: GardenPOIMarker },
  'gift-poi': { Component: GiftPOIMarker },
  'globe-poi': { Component: GlobePOIMarker },
  'golf-poi': { Component: GolfPOIMarker },
  'grocery-poi': { Component: GroceryPOIMarker },
  'hairdresser-poi': { Component: HairdresserPOIMarker },
  'harbor-poi': { Component: HarborPOIMarker },
  'hardware-poi': { Component: HardwarePOIMarker },
  'heart-poi': { Component: HeartPOIMarker },
  'heliport-poi': { Component: HeliportPOIMarker },
  'highway-rest-area-poi': { Component: HighwayrestareaPOIMarker },
  'home-poi': { Component: HomePOIMarker },
  'horse-riding-poi': { Component: HorseridingPOIMarker },
  'hospital-JP-poi': { Component: HospitaljpPOIMarker },
  'hospital-poi': { Component: HospitalPOIMarker },
  'hot-spring-poi': { Component: HotspringPOIMarker },
  'ice-cream-poi': { Component: IcecreamPOIMarker },
  'industry-poi': { Component: IndustryPOIMarker },
  'information-poi': { Component: InformationPOIMarker },
  'jewelry-store-poi': { Component: JewelrystorePOIMarker },
  'karaoke-poi': { Component: KaraokePOIMarker },
  'landmark-JP-poi': { Component: LandmarkjpPOIMarker },
  'landmark-poi': { Component: LandmarkPOIMarker },
  'landuse-poi': { Component: LandusePOIMarker },
  'laundry-poi': { Component: LaundryPOIMarker },
  'library-poi': { Component: LibraryPOIMarker },
  'lighthouse-JP-poi': { Component: LighthousejpPOIMarker },
  'lighthouse-poi': { Component: LighthousePOIMarker },
  'lodging-poi': { Component: LodgingPOIMarker },
  'logging-poi': { Component: LoggingPOIMarker },
  'marker-stroked-poi': { Component: MarkerstrokedPOIMarker },
  'mobile-phone-poi': { Component: MobilephonePOIMarker },
  'monument-JP-poi': { Component: MonumentjpPOIMarker },
  'monument-poi': { Component: MonumentPOIMarker },
  'mountain-poi': { Component: MountainPOIMarker },
  'museum-poi': { Component: MuseumPOIMarker },
  'music-poi': { Component: MusicPOIMarker },
  'natural-poi': { Component: NaturalPOIMarker },
  'observation-tower-poi': { Component: ObservationtowerPOIMarker },
  'optician-poi': { Component: OpticianPOIMarker },
  'paint-poi': { Component: PaintPOIMarker },
  'park-alt1-poi': { Component: Parkalt1POIMarker },
  'park-poi': { Component: ParkPOIMarker },
  'parking-garage-poi': { Component: ParkinggaragePOIMarker },
  'parking-poi': { Component: ParkingPOIMarker },
  'pharmacy-poi': { Component: PharmacyPOIMarker },
  'picnic-site-poi': { Component: PicnicsitePOIMarker },
  'pitch-poi': { Component: PitchPOIMarker },
  'place-of-worship-poi': { Component: PlaceofworshipPOIMarker },
  'playground-poi': { Component: PlaygroundPOIMarker },
  'police-JP-poi': { Component: PolicejpPOIMarker },
  'police-poi': { Component: PolicePOIMarker },
  'post-JP-poi': { Component: PostjpPOIMarker },
  'post-poi': { Component: PostPOIMarker },
  'prison-poi': { Component: PrisonPOIMarker },
  'racetrack-boat-poi': { Component: RacetrackboatPOIMarker },
  'racetrack-cycling-poi': { Component: RacetrackcyclingPOIMarker },
  'racetrack-horse-poi': { Component: RacetrackhorsePOIMarker },
  'racetrack-poi': { Component: RacetrackPOIMarker },
  'rail-light-poi': { Component: RaillightPOIMarker },
  'rail-metro-poi': { Component: RailmetroPOIMarker },
  'rail-poi': { Component: RailPOIMarker },
  'ranger-station-poi': { Component: RangerstationPOIMarker },
  'recycling-poi': { Component: RecyclingPOIMarker },
  'religious-buddhist-poi': { Component: ReligiousbuddhistPOIMarker },
  'religious-christian-poi': { Component: ReligiouschristianPOIMarker },
  'religious-jewish-poi': { Component: ReligiousjewishPOIMarker },
  'religious-muslim-poi': { Component: ReligiousmuslimPOIMarker },
  'religious-shinto-poi': { Component: ReligiousshintoPOIMarker },
  'residential-community-poi': { Component: ResidentialcommunityPOIMarker },
  'restaurant-bbq-poi': { Component: RestaurantbbqPOIMarker },
  'restaurant-noodle-poi': { Component: RestaurantnoodlePOIMarker },
  'restaurant-pizza-poi': { Component: RestaurantpizzaPOIMarker },
  'restaurant-seafood-poi': { Component: RestaurantseafoodPOIMarker },
  'restaurant-sushi-poi': { Component: RestaurantsushiPOIMarker },
  'restaurant-poi': { Component: RestaurantPOIMarker },
  'road-accident-poi': { Component: RoadaccidentPOIMarker },
  'roadblock-poi': { Component: RoadblockPOIMarker },
  'rocket-poi': { Component: RocketPOIMarker },
  'school-JP-poi': { Component: SchooljpPOIMarker },
  'school-poi': { Component: SchoolPOIMarker },
  'scooter-poi': { Component: ScooterPOIMarker },
  'shelter-poi': { Component: ShelterPOIMarker },
  'shoe-poi': { Component: ShoePOIMarker },
  'shop-poi': { Component: ShopPOIMarker },
  'skateboard-poi': { Component: SkateboardPOIMarker },
  'skiing-poi': { Component: SkiingPOIMarker },
  'slaughterhouse-poi': { Component: SlaughterhousePOIMarker },
  'slipway-poi': { Component: SlipwayPOIMarker },
  'snowmobile-poi': { Component: SnowmobilePOIMarker },
  'soccer-poi': { Component: SoccerPOIMarker },
  'square-stroked-poi': { Component: SquarestrokedPOIMarker },
  'square-poi': { Component: SquarePOIMarker },
  'stadium-poi': { Component: StadiumPOIMarker },
  'star-stroked-poi': { Component: StarstrokedPOIMarker },
  'star-poi': { Component: StarPOIMarker },
  'suitcase-poi': { Component: SuitcasePOIMarker },
  'swimming-poi': { Component: SwimmingPOIMarker },
  'table-tennis-poi': { Component: TabletennisPOIMarker },
  'teahouse-poi': { Component: TeahousePOIMarker },
  'telephone-poi': { Component: TelephonePOIMarker },
  'tennis-poi': { Component: TennisPOIMarker },
  'theatre-poi': { Component: TheatrePOIMarker },
  'toilet-poi': { Component: ToiletPOIMarker },
  'town-hall-poi': { Component: TownhallPOIMarker },
  'town-poi': { Component: TownPOIMarker },
  'triangle-stroked-poi': { Component: TrianglestrokedPOIMarker },
  'triangle-poi': { Component: TrianglePOIMarker },
  'veterinary-poi': { Component: VeterinaryPOIMarker },
  'viewpoint-poi': { Component: ViewpointPOIMarker },
  'village-poi': { Component: VillagePOIMarker },
  'volcano-poi': { Component: VolcanoPOIMarker },
  'volleyball-poi': { Component: VolleyballPOIMarker },
  'warehouse-poi': { Component: WarehousePOIMarker },
  'waste-basket-poi': { Component: WastebasketPOIMarker },
  'watch-poi': { Component: WatchPOIMarker },
  'water-poi': { Component: WaterPOIMarker },
  'waterfall-poi': { Component: WaterfallPOIMarker },
  'watermill-poi': { Component: WatermillPOIMarker },
  'wetland-poi': { Component: WetlandPOIMarker },
  'wheelchair-poi': { Component: WheelchairPOIMarker },
  'windmill-poi': { Component: WindmillPOIMarker },
  'zoo-poi': { Component: ZooPOIMarker },
  'zoom-in': { Component: ZoomInSVG },
};

export type IconName = keyof typeof iconsMap;

export interface IconProps extends ComponentPropsWithoutRef<ElementType<any>> {
  name: IconName;
}

const Icon: React.FC<IconProps> = ({ name, ...props }) => {
  const i = iconsMap[name];

  if (!i) {
    return null;
  }
  return <i.Component {...props} />;
};

export default Icon;
export { Icon, iconsMap };
